import React, { useContext, useState } from 'react'
import { M_Table, M_MessageBoard, M_Button, LoadingContext, BufferService, NavigateContext } from 'src/M_Components'
import { useTranslation } from 'react-i18next'

export const CommodityList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const [refresh, setRefresh] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [commodityToDelete, setCommodityToDelete] = useState()
    const commodityService = new BufferService('Commodity')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (operation, data) => {
        ctx.passValue?.set('operation', operation)

        if (operation === 'create') {
            ctx2.newTab('go/commodityDetail', t("CreateCommodity"))
            return
        }

        if (!data && selectedRows.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }

        if (operation === 'edit') {
            ctx.passValue.set('Row', data)
            ctx.passValue.set('Rows', selectedRows && selectedRows.length > 0 ? selectedRows : [data])
            ctx2.newTab('go/commodityDetail', t("EditCommodity"))
        }
    }

    const deleteCommodity = (data) => {
        if (!data) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        const id = Array.isArray(data) ? data[data.length - 1].Id : data.Id
        commodityService.delete(id).then(resData => {
            if (resData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorQuote"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessCommodityDeleted"))
            setRefresh(true)
            setOpenDeleteDialog(false)
        })
    }

    return (
        <div className='backgroundForms'>
            <div>
                <M_Table
                    roleName={'commodity'}
                    filtersOnTable
                    entityName={'Commodity'}
                    tablesOrder={tablesOrder}
                    onTablesOrderUpdate={onTablesOrderUpdate}
                    removeContextItems={['View', 'Copy']}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    rolePermissions={roles}
                    replaceFunctions={new Map([
                        ['Delete', (data) => {
                            setCommodityToDelete(data)
                            setOpenDeleteDialog(true)
                        }],
                        ['Create', (data) => NewRoute('create', data)],
                        ['Edit', (data) => NewRoute('edit', data)]
                    ])}
                    onPassLine={(rows) => setSelectedRows(rows)}
                />
            </div>
            <div className='dividerTables'></div>
            <M_MessageBoard
                warning
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                title={`${t("Delete")} ${t("Commodity")}?`}
                body={<span>{t("TitleConfirmDelete")} <b>{t("Commodity")}</b></span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteDialog(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteCommodity(commodityToDelete)}
                        />
                    </div>
                }
            />
        </div>
    )
}
